// extracted by mini-css-extract-plugin
module.exports = {"trigger":"ColorPicker_trigger__8QEEc","container":"ColorPicker_container__3Lk7o"};